import { MsisdnProcedureInterfaceState, initialMsisdnProcedureState } from '../state/msisdn-procedure.state';
import { MsisdnProceduresActions, EMsisdnProceduresActions } from '../actions/msisdn-procedures.actions';

export function msisdnProceduresReducer(state: MsisdnProcedureInterfaceState = initialMsisdnProcedureState, action: MsisdnProceduresActions): MsisdnProcedureInterfaceState {
  switch (action.type) {
    case EMsisdnProceduresActions.GetMsisdnProceduresSuccess: {
      return { ...state, msisdnProcedures: action.payload };
    }

    default:
      return state;
  }
};
